import { useState, useEffect } from "react";
import { EntriesApi, Configuration } from "manager-common";
import { useAuth } from "react-oidc-context";
import { useApiConfig } from "common-fe";
import { useTranslation } from "i18n-fe";

const MANAGER_API_BASE_URL = import.meta.env.VITE_MANAGER_API_BASE_URL;

export function useShowEntries(showId) {
  const auth = useAuth();
  const buildConfig = useApiConfig();
  const { t } = useTranslation("common");
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!showId) {
      setEntries([]);
      setLoading(false);
      setError(null);
      return;
    }

    const fetchEntries = async () => {
      if (!auth.user?.access_token) {
        setError(t("shows.detail.authError"));
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        const api = new EntriesApi(
          new Configuration(buildConfig(MANAGER_API_BASE_URL))
        );
        const { data } = await api.getShowEntries(showId);
        setEntries(data);
        setError(null);
      } catch (err) {
        console.error("Error fetching show entries:", err);
        setError(t("shows.detail.error"));
      } finally {
        setLoading(false);
      }
    };

    fetchEntries();
  }, [showId, auth.user, buildConfig, t]);

  return { entries, loading, error };
}
